/** @file Home of the toggle component. */
import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
import * as constants from '../constants';
import { injectFieldContext, useFieldContextValue } from '../context';
/** Toggle renders a checkbox disguised as a toggle and looks coherent with the rest of the form components. */
export const Toggle = tsx.withHtmlAttrs(tsx.componentFactoryOf().create({
    name: `${constants.nameToggle}`,
    inject: injectFieldContext(),
    computed: useFieldContextValue(),
    props: {
        checked: p(Boolean).required,
        disabled: p(Boolean).default(false),
    },
    /** @returns Nodes. */
    render() {
        return (<label data-cy={constants.nameToggle} data-checked={this.checked} data-disabled={this.disabled} class={[
                constants.nameControl,
                constants.nameToggle,
                'data-disabled:cursor-not-allowed not-data-disabled:cursor-pointer',
                'm-0 w-14 rounded-full flex items-center p-0.5 min-h-auto shadow-inner',
                'focus-within:outline-2 outline-actionable-30',
                'focus-within:ring-3 ring-white',
                'transition-colors duration-200 ease-in-out',
                'overflow-hidden',
                'border-0',
                {
                    'cursor-not-allowed': this.disabled,
                    'cursor-pointer': !this.disabled,
                },
                {
                    'bg-neutral-10 dark:bg-neutral-20': !this.checked,
                    'bg-neutral-20 dark:bg-neutral-30': !this.checked && this.disabled,
                    'bg-neutral-30 dark:bg-neutral-40': this.checked && this.disabled,
                    'bg-brand-40 dark:bg-positive-40': this.checked && !this.disabled,
                },
            ]} for={this.fieldContext.inputId}>
                    <input id={this.fieldContext.inputId} aria-describedby={this.fieldContext.descriptionId} class="peer sr-only" type="checkbox" checked={this.checked} disabled={this.disabled} onInput={evt => {
                tsx.emitOn(this, 'onInput', evt.target.checked);
            }}/>
                    <div role="img" aria-hidden class={[
                'shadow-xs',
                'transition-transform duration-200 ease-toggle',
                'rounded-full size-6',
                'transform',
                {
                    'translate-x-7': this.checked,
                    'bg-white dark:bg-brand-80': !this.disabled,
                    'bg-neutral-5 dark:bg-neutral-60': this.disabled,
                },
            ]}/>
                </label>);
    },
}));
